import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '夜勤病栋 - 深度解析站',
  url: 'https://jinglianwl.cn',
  description: '深度解析经典恐怖作品《夜勤病栋》的剧情、人物与文化影响，探寻深夜病房背后的黑暗秘密。',
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '夜勤病栋解析站',
  url: 'https://jinglianwl.cn',
  description: '专注于经典恐怖作品《夜勤病栋》的深度解析与文化交流平台。',
  sameAs: [],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
      </main>
    </>
  );
}